// MapSection.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiInstagram } from 'react-icons/fi';
import { FaTiktok } from 'react-icons/fa';
import '../../../../assets/css/customer/subscreens/contact/ContactMapSection.css';

const MapSection = () => {
  const socialLinks = [
    { icon: <FiFacebook />, name: 'Facebook', url: 'https://www.facebook.com/share/1DKPSpqVN2/' },
    { icon: <FiInstagram />, name: 'Instagram', url: 'https://www.instagram.com/crafthive__?igsh=MTVwOHd6ZTZqdncxOQ==' },
    { icon: <FaTiktok />, name: 'TikTok', url: '#' }
  ];

  return (
    <div className="map-wrapper">
      <h2 className="map-title">Find Us Here</h2>
      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.9663095343008!2d-74.00425878459253!3d40.74076894379132!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259bf5c1654f3%3A0xc80f9cfce5383d5d!2sGoogle!5e0!3m2!1sen!2sus!4v1635880787876!5m2!1sen!2sus"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          title="CraftHive Location"
        ></iframe>
      </div>

      <div className="social-section">
        <h3 className="social-title">Follow Us</h3>
        <div className="social-links">
          {socialLinks.map((social, index) => (
            <Link
              key={index}
              to={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label={social.name}
            >
              {social.icon}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MapSection;